import { render, staticRenderFns } from "./FormResearchesReviewBoard.vue?vue&type=template&id=00aac0a0&"
import script from "./FormResearchesReviewBoard.vue?vue&type=script&lang=js&"
export * from "./FormResearchesReviewBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports